import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Cedente } from "../models/cedente";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { CedenteGestorCadastro } from "../models/cedentegestor-cadastro";
import { CedenteGestor } from "../models/cedentegestor";
import { ResponseBase } from "../models/response-base";
import { CedenteInfo } from "../models/cedente-info";
import { SaldoPessoa } from "../models/saldo-pessoa";
import { LocalStoreKeys } from "../shared/helpers/localstorage/local-store";
import { Address, AddressType } from "../models/address";
import { Assignor } from "../models/assignor";
import { AssignorLead } from "../models/gestor-cadastro";

@Injectable({
    providedIn: "root"
})
export class CedenteService {
    API: string = environment.API + "Portal/cedentes";

    private currentBalanceSubject: BehaviorSubject<SaldoPessoa[]>;

    constructor(private http: HttpClient) {
    }

    add(cedenteGestor: CedenteGestorCadastro): Observable<ResponseBase<CedenteGestor>> {
        return this.http.post<ResponseBase<CedenteGestor>>(this.API,cedenteGestor);
    }

    getAll(gestorId: string): Observable<ResponseBase<[Cedente]>> {
        return this.http.get<ResponseBase<[Cedente]>>(`${this.API}/gestores/${gestorId}`);
    }

    getInfo(cedenteGuid: string,gestorGuid: string, ignoreLoader: boolean = false): Observable<ResponseBase<CedenteInfo>> {
        let headers = new HttpHeaders();
        if(ignoreLoader){
            headers = headers.append('no-loader', 'true');
        }

        return this.http.get<ResponseBase<CedenteInfo>>(`${this.API}/${cedenteGuid}/gestores/${gestorGuid}/info`, {headers});
    }

    editInfo(cedenteGuid: string, gestorGuid: string, cedenteInfo: CedenteInfo): Observable<ResponseBase<CedenteInfo>> {
        return this.http.put<ResponseBase<CedenteInfo>>(`${this.API}/${cedenteGuid}/gestores/${gestorGuid}/info`, cedenteInfo);
    }

    getParametros(
        cedenteGuid: string,
        gestorGuid: string
    ): Observable<ResponseBase<{ [key: string]: any }>> {
        return this.http.get<ResponseBase<{ [key: string]: any }>>(
            `${this.API}/${cedenteGuid}/gestor/${gestorGuid}/parametros`
        );
    }

    getAuthAssignorInfo(assignorGuid: string): Observable<ResponseBase<any>>{
        return this.http.get<ResponseBase<any>>(`${this.API}/${assignorGuid}`);
    }


    /* NEW MICRO SERVICE */

    URL: string = environment.GATEWAY + 'assignors';

    // ASSIGNOR

    registerAssignorLead(assignorLead: AssignorLead): Observable<ResponseBase<boolean>> {
        let headers = new HttpHeaders();
        headers = headers.append('no-loader', 'true');
        return this.http.post<ResponseBase<boolean>>(`${this.URL}/register/lead`, assignorLead, { headers });
    }

    getAssignorInfo(assignorGuid: string, managerGuid: string, ignoreLoader: boolean = false): Observable<ResponseBase<Assignor>>{
        let headers = new HttpHeaders();
        if(ignoreLoader){
            headers = headers.append('no-loader', 'true');
        }

        return this.http.get<ResponseBase<Assignor>>(`${this.URL}/${assignorGuid}/manager/${managerGuid}/info`, {headers});
    }

    updateAssignor(assignorGuid: string, managerGuid: string, updateAssingor: Assignor): Observable<ResponseBase<Assignor>>{
        return this.http.put<ResponseBase<any>>(`${this.URL}/${assignorGuid}/manager/${managerGuid}/update`, updateAssingor);
    }

    pinChagePhone(managerGuid: string): Observable<ResponseBase<any>>{
        return this.http.get<ResponseBase<any>>(`${this.URL}/${managerGuid}/phone/pin`);
    }

    editPhone(managerGuid: string, phone: string, codigo: number): Observable<ResponseBase<any>>{
        
        let params = new HttpParams();
        params = params.append('phone', phone.toString());
        params = params.append('codigo', codigo.toString());

        return this.http.post<ResponseBase<any>>(`${this.URL}/${managerGuid}/phone/edit`, null, {params});
    }

    // ADDRESS

    getAddressTypes(): Observable<ResponseBase<AddressType[]>>{
        return this.http.get<ResponseBase<AddressType[]>>(`${this.URL}/address/types`);
    }

    getAddress(assignorGuid: string, addressTypeId: number): Observable<ResponseBase<Address>>{
        return this.http.get<ResponseBase<Address>>(`${this.URL}/address/${assignorGuid}/type/${addressTypeId}`);
    }

    createAddress(assignorGuid: string, createAddress: Address): Observable<ResponseBase<number>>{
        return this.http.post<ResponseBase<number>>(`${this.URL}/address/create/${assignorGuid}`, createAddress);
    }

    updateAddress(assignorGuid: string, updateAddress: Address): Observable<ResponseBase<boolean>>{
        return this.http.put<ResponseBase<boolean>>(`${this.URL}/address/update/${assignorGuid}`, updateAddress);
    }
}
